module.exports = __webpack_public_path__ + "img/waterbg.5426712d.jpg";